<div class="popup-container d-flex flex-column">
  <label class="heading-text"> Update Govt. ID Proof </label>
  <!-- <label class="content"
    >You can add any one ID proof</label
  > -->
  <form>
    <div class="comment-div d-flex justify-content-between flex-column">
      <div class="custom-dropdown">
        <!-- <span class="comments">Select id Type</span>
        <mat-form-field class="select-mat-form-field custom-select-form" style="margin-top: 4px;">
          <mat-select
            class="custom-mat-select custom-select"
            id="state"
            [formControl]="selectedIdType"
            placeholder="Select State"
          >
            <mat-option
              *ngFor="let type of typeList; let i = index"
              [value]="type"
            >
              {{ type }}
            </mat-option>
          </mat-select>
        </mat-form-field> -->
        <select id="dropdown" [formControl]="selectedIdType">
          <option value="" disabled>Select ID Type</option>
          <option *ngFor="let option of typeList" [value]="option">
            {{ option }}
          </option>
        </select>
      </div>
      @if (selectedIdType.value) {
      <div style="display: flex; flex-direction: column; gap: 4px">
        <input style="width: 100%" type="text" placeholder="Enter id in CAPS" [formControl]="idValue"
          class="dp-input-control comment-text" />
        <div *ngIf="idValue.invalid && idValue.touched">
          <small style="color: var(--brand-destructive)" *ngIf="idValue.errors?.['required']">ID value is
            required</small>
          <small style="color: var(--brand-destructive)" *ngIf="idValue.errors?.['pattern']">Invalid format</small>
        </div>
      </div>
      <div style="display: flex; flex-direction: column; gap: 4px">
        <input style="width: 100%" type="text" placeholder="Enter name as per ID" [formControl]="govtName"
          class="dp-input-control comment-text" />
      </div>
      <!-- <div class="dp-primary-btn"> -->
      <input type="file" id="fileUpload" accept=".jpg,.jpeg,.png" (change)="onFileSelected($event)" hidden />
      @if(!fileName){
      <label for="fileUpload" class="dp-secondary-btn custom-upload-button">
        {{ "+ Upload file" }}
      </label>
      }@else{
      <div class="selected-file">
        <span>{{ fileName }}</span>
        <div class="cross-ico" (click)="deleteFile()"></div>
      </div>
      }
      <!-- </div> -->
      }
    </div>
  </form>
  <div class="btn-div d-flex flex-column">
    <button class="btn-content" (click)="saveAndUpload()">
      <span>{{this.data.rowData.docUploaded=='No' && this.data.rowData.docSubmitted=='No' ? 'Save':'Update'}}</span>
    </button>
    <button class="dp-tertiary-btn btn-cancel" mat-dialog-close>Cancel</button>
  </div>
</div>
<app-loader [isLoading]="isLoading"></app-loader>